const topperSection = document.querySelector('.topper-home');
const topperVideo = document.querySelector('.fullscreen-bg__video');
const playPauseTopper = document.querySelector('.topper-pause');
const playPauseTopperText = document.querySelector('.button-text');

if (playPauseTopper) {
	topperVideo.classList.toggle('video-ready');

	playPauseTopper.addEventListener('click', pauseTopper);

	function toggleTopperClass() {
		topperSection.classList.toggle('video-paused');
	}

	function pauseTopper() {
		toggleTopperClass();
		if (topperVideo.paused) {
			topperVideo.play();
			playPauseTopperText.innerText = 'Pause';
		} else {
			topperVideo.pause();
			playPauseTopperText.innerText = 'Play';
		}
	}
}
